// Legacy admin-rejected records remain review work; policy 2 means invalid patient information.
export function ivrOutcome(record) {
  return record?.status === 'rejected' && record?.statusPolicyVersion !== 2
    ? 'needs_review' : record?.status;
}
